/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as ActorDefs from "../../../app/bsky/actor/defs.defs.js";

const $nsid = "place.stream.broadcast.defs";

export { $nsid };

type BroadcastOriginView = { $type?: "place.stream.broadcast.defs#broadcastOriginView";"uri":l.AtUriString;"cid":l.CidString;"author":ActorDefs.ProfileViewBasic;"record":l.LexMap };

export type { BroadcastOriginView };

const broadcastOriginView = /*#__PURE__*/ l.typedObject<BroadcastOriginView>($nsid, "broadcastOriginView", /*#__PURE__*/ l.object({"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"cid":/*#__PURE__*/ l.string({"format":"cid"}),"author":/*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>((() => ActorDefs.profileViewBasic) as any),"record":/*#__PURE__*/ l.lexMap()}));

export { broadcastOriginView };
